/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	let lang = location.pathname.split('/')[1];
	if(location.pathname.split('/')[1] === 'global') {
		lang = 'glo';
	}
	const a = 'is-active';
	const v = 'is-visible';
	// alt属性用テキスト変換（HTMLタグを除去してエスケープ）
	const toAltText = (str) => {
		if(!str) {
			return '';
		}
		const text = new DOMParser().parseFromString(String(str).replace(/<br\s*\/?>/gi, ' '), 'text/html').body.textContent;
		return text.replace(/\s+/g, ' ').trim()
			.replace(/&/g, '&amp;')
			.replace(/"/g, '&quot;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;');
	};
	const slider = () => {
		if($('.consumer-slide03').length) {
			$('.consumer-slide03').slick({
				autoplay: false,
				slidesToShow: 4,
				slidesToScroll: 1,
				dots: false,
				arrows: false,
				infinite: true,
				draggable: false,
				responsive: [{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						dots: true,
						draggable: true,
					}
				}]
			});
			// for (let i=0; i < $('.consumer-slide03').length; i++) {
			// 	let imgHeight = $('.consumer-slide03-item img').eq(i).height() / 2;
			// 	let arrowpos = imgHeight - ($('.consumer-slide03').eq(i).find('.slick-arrow').height() / 2);
			// 	$('.consumer-slide03').eq(i).find('.slick-arrow').css('top',arrowpos);
			// }
		}
		if($('.consumer-detail-slide02').length) {
			// トグルがデフォルトで開いてるパターン
			$('.consumer-detail-slide02-item').each((idx, val) => {
				if(!$(val).find('img').length) {
					$(val).remove();
				}
			});
			$('.consumer-detail-slide02-thumbnail-item').each((idx, val) => {
				if(!$(val).find('img').length) {
					$(val).remove();
				}
			});
			$('.consumer-detail-slide02-slider').slick({
				autoplay: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: false,
				arrows: true,
				prevArrow: '<a class="slick-prev" href="#"><svg class="slick-arrow_img"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>',
				nextArrow: '<a class="slick-next" href="#"><svg class="slick-arrow_img"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>',
				asNavFor: '.consumer-detail-slide02-thumbnail',
			});
			$('.consumer-detail-slide02-thumbnail').slick({
				slidesToShow: 6,
				asNavFor: '.consumer-detail-slide02-slider',
				focusOnSelect: true,
			});
			$(window).on('load', function(){
				for (let i=0; i < $('.consumer-detail-slide02-slider').length; i++) {
					let imgHeight = $('.consumer-detail-slide02-slider-item img').eq(i).height() / 2;
					// console.log(imgHeight);
					let arrowpos = imgHeight - ($('.consumer-detail-slide02-slider').eq(i).find('.slick-arrow').height() / 2);
					$('.consumer-detail-slide02-slider').eq(i).find('.slick-arrow').css('top',arrowpos);
				}
			});
			// トグルがデフォルトで閉じてるパターン
			// $('.consumer-detail-slide02-toggle').on('click', function(){
			// 	if(!$(this).hasClass('is-slide')) {
			// 		$(this).addClass('is-slide');
			// 		$('.consumer-detail-slide02-item').each((idx, val) => {
			// 			if(!$(val).find('img').length) {
			// 				$(val).remove();
			// 			}
			// 		});
			// 		$('.consumer-detail-slide02-thumbnail-item').each((idx, val) => {
			// 			if(!$(val).find('img').length) {
			// 				$(val).remove();
			// 			}
			// 		});
			// 		$('.consumer-detail-slide02-slider').slick({
			// 			autoplay: false,
			// 			slidesToShow: 1,
			// 			slidesToScroll: 1,
			// 			dots: false,
			// 			arrows: true,
			// 			prevArrow: '<a class="slick-prev" href="#"><svg class="slick-arrow_img"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>',
			// 			nextArrow: '<a class="slick-next" href="#"><svg class="slick-arrow_img"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>',
			// 			asNavFor: '.consumer-detail-slide02-thumbnail',
			// 		});
			// 		$('.consumer-detail-slide02-thumbnail').slick({
			// 			slidesToShow: 5,
			// 			asNavFor: '.consumer-detail-slide02-slider',
			// 			focusOnSelect: true,
			// 		});
			// 		setTimeout(() => {
			// 			for (let i=0; i < $('.consumer-detail-slide02-slider').length; i++) {
			// 				let imgHeight = $('.consumer-detail-slide02-slider-item img').eq(i).height() / 2;
			// 				console.log(imgHeight);
			// 				let arrowpos = imgHeight - ($('.consumer-detail-slide02-slider').eq(i).find('.slick-arrow').height() / 2);
			// 				$('.consumer-detail-slide02-slider').eq(i).find('.slick-arrow').css('top',arrowpos);
			// 			}
			// 		}, 100);
			// 	}
			// });
		}
	};
	const consumerFilter = () => {
		if($('.js-consumer-filter-button').length) {
			$('.js-consumer-filter-button').on('click', function(){
				$('.js-consumer-filter-button').toggleClass(a);
				$('.js-consumer-filter-block').toggleClass('di_none');
			});
		}
		if($('.js-consumer-form').length) {
			// パラメータ取得
			const getParam = (name, url) => {
				if (!url) url = window.location.href;
				name = name.replace(/[\[\]]/g, '\\$&');
				var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
					results = regex.exec(url);
				if (!results) return null;
				if (!results[2]) return '';
				return decodeURIComponent(results[2].replace(/\+/g, ' '));
			};
			$('input').change(function(){
				$('.js-consumer-form').submit();
			});
			if($('.js-consumer-form-lens_type').length) {
				let lensType = $('.js-consumer-form-lens_type');
				let model = $('.js-consumer-form-model');
				let mount = $('.js-consumer-form-mount');
				let lensTypeKey = '';
				let modelId = '';
				const getJSONlenstype = () => {
					return $.getJSON(`/ajax/${lang}/consumer/lens_type.json`);
				};
				const getJSONmodel = (_key) => {
					return $.getJSON(`/ajax/${lang}/consumer/${_key}/model.json`);
				};
				const getJSONmount = (_id) => {
					return $.getJSON(`/ajax/${lang}/consumer/${_id}/mount.json`);
				};
				// 初期表示
				getJSONlenstype().done((data) => {
					// console.log(data,'data');
					data.rt_bn_lens_type_list.forEach((elem) => {
						if(!(getParam('lens_type') == elem._key)) {
							lensType.append($('<option>').html(elem.rt_cf_pt_name_d.content).val(elem._key));
						} else {
							lensType.append($('<option>').html(elem.rt_cf_pt_name_d.content).val(elem._key).prop('selected', true));
							lensTypeKey = elem._key;
						}
					});
					lensType.removeClass('pointer-eventNone');
					if((model.length) && (lensTypeKey)) {
						getJSONmodel(lensTypeKey).done((data2) => {
							// console.log(data2,'datadata');
							data2.rt_bn_model_list.forEach((elem) => {
								if(!(getParam('product_id') == elem._key)) {
									if(elem.cf_p_mount) {
										let countmount = 0;
										for(let i=0; i < elem.cf_p_mount.length; i++) {
											if(elem.cf_p_mount[i].cf_plm_end_of_sale_flag == 1) {
												countmount += 1;
											}
										}
										if(!(countmount == elem.cf_p_mount.length)) {
											model.append($('<option>').html(elem.cf_p_title).val(elem._key));
										}
									}
								} else {
									model.append($('<option>').html(elem.cf_p_title).val(elem._key).prop('selected', true));
									modelId = elem._key;
								}
							});
							model.removeClass('pointer-eventNone');
							if((mount.length) && (modelId)) {
								getJSONmount(modelId).done((data3) => {
									// console.log(data3,'datadata3');
									data3.rt_bn_mount_list.forEach((elem) => {
										if(!(getParam('mount_id') == elem._key)) {
											mount.append($('<option>').html(elem.cf_plm_mount_name).val(elem._key));
										} else {
											mount.append($('<option>').html(elem.cf_plm_mount_name).val(elem._key).prop('selected', true));
										}
									});
									mount.removeClass('pointer-eventNone');
								});
							}
						});
					}
				});
				// change
				lensType.change(function(){
					if(model.length) {
						model.val('');
					}
					if(mount.length) {
						mount.val('');
					}
					$('.js-consumer-form').submit();
				});
				model.change(function(){
					if(mount.length) {
						mount.val('');
					}
					$('.js-consumer-form').submit();
				});
				mount.change(function(){
					$('.js-consumer-form').submit();
				});
				// clear
				if($('.js-consumer-filter-clear').length) {
					$('.js-consumer-filter-clear').on('click', function(){
						$('input[type="text"]').val('');
						$('input').prop('checked', false);
						if(lensType.length) {
							lensType.val('');
						}
						if(model.length) {
							model.val('');
						}
						if(mount.length) {
							mount.val('');
						}
						$('.js-consumer-form').submit();
					});
				}
			}
		}
		if($('.js-consumer-lenses-detail-form').length) {
			$('.js-consumer-lenses-detail-form').attr('action', (location.pathname+'#nav'));
			$('.js-consumer-lenses-detail-form input').change(function(){
				$('.js-consumer-lenses-detail-form').submit();
			});
		}
	};
	const consumerDetailNav = () => {
		if($('.js-consumer-detail-nav').length) {
			$(window).on('scroll', function(){
				let thisScroll = $(window).scrollTop();
				let navPos = $('.js-consumer-detail-nav').offset().top;
				if(thisScroll > navPos) {
					$('.js-consumer-detail-nav').addClass(v);
					setTimeout(() => {
						$('.js-consumer-detail-nav').addClass(a);
					}, 300);
				} else {
					$('.js-consumer-detail-nav').removeClass(v);
					$('.js-consumer-detail-nav').removeClass(a);
				}
			});
			// 詳細ナビ項目・存在チェック
			const getJSONimp = () => {
				return $.getJSON(`/ajax/${lang}/consumer/lenses/imp/${location.pathname.split('/')[4]}.json`);
			};
			const getJSONsamp = () => {
				return $.getJSON(`/ajax/${lang}/consumer/lenses/samp/${location.pathname.split('/')[4]}.json`);
			};
			const getJSONvideo = () => {
				return $.getJSON(`/ajax/${lang}/consumer/lenses/video/${location.pathname.split('/')[4]}.json`);
			};
			const getJSONreview = () => {
				return $.getJSON(`/ajax/${lang}/consumer/lenses/review/${location.pathname.split('/')[4]}.json`);
			};
			if(!($('.consumer-soft-lensutility').length)) {
				// 「概要」以外にスクロール用id追加
				$('.consumer-detail-nav li').each((idx, val) => {
					if(!(idx == '0')) {
						let thisHref = $(val).find('a').attr('href') + '#nav';
						$(val).find('a').attr('href',thisHref);
					}
				});
				$('.consumer-detail-nav-float-content-item-nav li').each((idx, val) => {
					if(!(idx == '0')) {
						let thisHref = $(val).find('a').attr('href') + '#nav';
						$(val).find('a').attr('href',thisHref);
					}
				});
			}
			// アイテムのカレントがついていたら表示
			if($('.js-consumer-detail-nav-imp').find('.is-active').length) {
				$('.js-consumer-detail-nav-imp').removeClass('is-hidden');
			}
			if($('.js-consumer-detail-nav-samp').find('.is-active').length) {
				$('.js-consumer-detail-nav-samp').removeClass('is-hidden');
			}
			if($('.js-consumer-detail-nav-video').find('.is-active').length) {
				$('.js-consumer-detail-nav-video').removeClass('is-hidden');
			}
			if($('.js-consumer-detail-nav-review').find('.is-active').length) {
				$('.js-consumer-detail-nav-review').removeClass('is-hidden');
			}
			if(!($('.consumer-soft-lensutility').length)) {
				// 各JSONでexistがあれば表示
				Promise.all([
					getJSONimp(),
					getJSONsamp(),
					getJSONvideo(),
					getJSONreview()
				]).then(function(data) {
					// console.log(data,"okok");
					data.forEach((item, index) => {
						if(item.rt_bn_imp_exist) {
							if(item.rt_bn_imp_exist.length) {
								if(item.rt_bn_imp_exist[0].rt_bn_imp_exist.content === 'exist') {
									$('.js-consumer-detail-nav-imp').removeClass('is-hidden');
								}
							}
						}
						if(item.rt_bn_sample_exist) {
							if(item.rt_bn_sample_exist.length) {
								if(item.rt_bn_sample_exist[0].rt_bn_sample_exist.content === 'exist') {
									$('.js-consumer-detail-nav-samp').removeClass('is-hidden');
								}
							}
						}
						if(item.rt_bn_video_exist) {
							if(item.rt_bn_video_exist.length) {
								if(item.rt_bn_video_exist[0].rt_bn_video_exist.content === 'exist') {
									$('.js-consumer-detail-nav-video').removeClass('is-hidden');
								}
							}
						}
						if(item.rt_bn_review_exist) {
							if(item.rt_bn_review_exist.length) {
								if(item.rt_bn_review_exist[0].rt_bn_review_exist.content === 'exist') {
									$('.js-consumer-detail-nav-review').removeClass('is-hidden');
								}
							}
						}
					});
				})
			}
		}
	};
	const modal = () => {
		// /jp/consumer/lenses/detail/spec.htmlで使用
		$('.js-consumer-detail-modal01').on('click', (e) => {
			let HTML = '<div class="consumer-detail-modal01-overlay">';
			if(lang === 'jp') {
				HTML +=
				'<div class="consumer-detail-modal01-closeArea"></div>'+
				'<div class="consumer-detail-modal01-content"><div class="consumer-detail-modal01-content-in"><span class="consumer-detail-modal01-closeBtn"><span></span></span><h4 class="mod-head05 ta_center"><span class="">MTFの見方</span></h4><p class="mod-spacer-32_24">被写体の持つコントラストを、レンズを通してどの程度忠実に再現できるかを表したのがMTF(Modulation Transfer Function)曲線図です。</p><p class="mod-spacer-16_8">MTF曲線図の10本／mm(低周波)のカーブが1に近いほどコントラストの再現性がよく、ヌケの良いレンズとなり、30本／mm(高周波)のカーブが1に近いほど解像性のよいシャープなレンズとなります。</p><p class="mod-spacer-16_8">また、画面の放射方向(サジタル・実線)と円周方向(メリジオナル・破線)によっても、カーブが異なります。</p><p class="mod-spacer-16_8">シャープで抜けがよく、画面全体で均質な性能を得るには、それぞれのカーブのバランスが取れていることが大切です。</p><p class="mod-spacer-16_8">なお、レンズ性能は、ボケ味や各種収差の状況など、MTF曲線図だけでは表せない側面もあります。MTF曲線図は、レンズ性能を表す尺度のひとつとしてご利用いただけます。</p></div></div>'
				'</div>';
			} else {
				HTML +=
				'<div class="consumer-detail-modal01-closeArea"></div>'+
				'<div class="consumer-detail-modal01-content"><div class="consumer-detail-modal01-content-in"><span class="consumer-detail-modal01-closeBtn"><span></span></span><h4 class="mod-head05 ta_center"><span class="">MTF Chart Guide</span></h4><p class="mod-spacer-32_24">MTF (Modulation Transfer Function) curves describe to what extent the tested lens can faithfully reproduce contrast of the subject in images it captures.</p><p class="mod-spacer-16_8">The closer the 10 lp/mm (line pairs per millimeter) curve (the thick line for low frequency) in an MTF chart to "1" of the vertical axis (the higher up), the higher the contrast reproduction performance of the tested lens will be. The closer the 30 lp/mm curve (the thin line for high frequency) to "1" (the higher up), the higher the resolving power and thus the subjective sharpness of the lens will be.</p><p class="mod-spacer-16_8">Lens performance differs depending upon directions. Solid lines show performance in the sagittal (radial) direction while dotted lines indicate performance in the meridional (circumferential) direction. When sharp lenses capable of delivering uniform optical performance over the entire image field are tested, MTF charts show curves plotted in good balance.</p><p class="mod-spacer-16_8">Performance characteristics of photographic lenses cannot be expressed with only MTF charts. There are other factors that are expressed in different methods, such as taste of softness and degrees of compensation of various aberrations. But you can use MTF charts as a scale to measure lens performance.</p></div></div>'
				'</div>';
			}
			$('body').append(HTML);
			const $overlay = $('.consumer-detail-modal01-overlay');
			$overlay.addClass(a);
			setTimeout(() => {
				$overlay.addClass(v);
				$('.consumer-detail-modal01-closeArea, .consumer-detail-modal01-closeBtn').on('click', () => {
					$overlay.removeClass(v);
					setTimeout(() => {
						$overlay.removeClass(a);
						$overlay.remove();
					}, 400);
				});
			});
		});
	};
	const moreItem = () => {
		if($('.js-consumer-moreItem_5_all').length) {
			for (let i=0; i < $('.js-consumer-moreItem_5_all > li').length; i++) {
				if(i < 5) {
					$('.js-consumer-moreItem_5_all > li').eq(i).removeClass('di_none');
				}
			}
			$('.js-consumer-moreItem_5_all-button').removeClass('di_none');
			if($('.js-consumer-moreItem_5_all > li').length < 6) {
				$('.js-consumer-moreItem_5_all-button').addClass('di_none');
			}
			$('.js-consumer-moreItem_5_all-button').on('click', function(){
				$('.js-consumer-moreItem_5_all > li').removeClass('di_none');
				$(this).addClass('di_none');
			});
		}
		if($('.js-consumer-moreItem_8_all').length) {
			for (let i=0; i < $('.js-consumer-moreItem_8_all > li').length; i++) {
				if(i < 8) {
					$('.js-consumer-moreItem_8_all > li').eq(i).removeClass('di_none');
				}
			}
			$('.js-consumer-moreItem_8_all-button').removeClass('di_none');
			if($('.js-consumer-moreItem_8_all > li').length < 9) {
				$('.js-consumer-moreItem_8_all-button').addClass('di_none');
			}
			$('.js-consumer-moreItem_8_all-button').on('click', function(){
				$('.js-consumer-moreItem_8_all > li').removeClass('di_none');
				$(this).addClass('di_none');
			});
		}
		if($('.js-consumer-moreItem_15_15').length) {
			for (let i=0; i < $('.js-consumer-moreItem_15_15 > li').length; i++) {
				if(i < 15) {
					$('.js-consumer-moreItem_15_15 > li').eq(i).removeClass('di_none');
				}
			}
			$('.js-consumer-moreItem_15_15-button').removeClass('di_none');
			if($('.js-consumer-moreItem_15_15 > li').length < 16) {
				$('.js-consumer-moreItem_15_15-button').addClass('di_none');
			}
			$('.js-consumer-moreItem_15_15-button').on('click', function(){
				for (let i=0; i < $('.js-consumer-moreItem_15_15 > li.di_none').length; i++) {
					if(i < 15) {
						$('.js-consumer-moreItem_15_15 > li.di_none').eq(i).addClass('is-hidden');
					}
				}
				$('.js-consumer-moreItem_15_15 > li.is-hidden').removeClass('di_none');
				if(!($('.js-consumer-moreItem_15_15 > li.di_none').length)) {
					$(this).addClass('di_none');
				}
			});
			$('.js-consumer-moreItem_15_15 > li').waypoint(function(direction){
				var activePoint = $(this.element);
				if(direction === 'down') { // scroll down
					activePoint.addClass(a);
				} else { // scroll up
					activePoint.removeClass(a);
				}
			}, { offset : '70%' });
		}
		if($('.js-consumer-moreItem_6_6').length) {
			for (let m=0; m < $('.js-consumer-moreItem_6_6').length; m++) {
				let ulElement = $('.js-consumer-moreItem_6_6').eq(m);
				let btnElement = $('.js-consumer-moreItem_6_6').eq(m).next('.js-consumer-moreItem_6_6-button');
				for (let i=0; i < ulElement.children('li').length; i++) {
					if(i < 6) {
						ulElement.children('li').eq(i).removeClass('di_none');
					}
				}
				btnElement.removeClass('di_none');
				if(ulElement.children('li').length < 7) {
					btnElement.addClass('di_none');
				}
				btnElement.on('click', function(){
					for (let i=0; i < ulElement.children('li.di_none').length; i++) {
						if(i < 6) {
							ulElement.children('li.di_none').eq(i).addClass('is-hidden');
						}
					}
					ulElement.children('li.is-hidden').removeClass('di_none');
					if(!(ulElement.children('li.di_none').length)) {
						$(this).addClass('di_none');
					}
				});
				ulElement.children('li').waypoint(function(direction){
					var activePoint = $(this.element);
					if(direction === 'down') { // scroll down
						activePoint.addClass(a);
					} else { // scroll up
						activePoint.removeClass(a);
					}
				}, { offset : '70%' });
			}
		}
		if($('.js-consumer-moreItem_5_5').length) {
			for (let i=0; i < $('.js-consumer-moreItem_5_5 > li').length; i++) {
				if(i < 5) {
					$('.js-consumer-moreItem_5_5 > li').eq(i).removeClass('di_none');
				}
			}
			$('.js-consumer-moreItem_5_5-button').removeClass('di_none');
			if($('.js-consumer-moreItem_5_5 > li').length < 6) {
				$('.js-consumer-moreItem_5_5-button').addClass('di_none');
			}
			$('.js-consumer-moreItem_5_5-button').on('click', function(){
				for (let i=0; i < $('.js-consumer-moreItem_5_5 > li.di_none').length; i++) {
					if(i < 5) {
						$('.js-consumer-moreItem_5_5 > li.di_none').eq(i).addClass('is-hidden');
					}
				}
				$('.js-consumer-moreItem_5_5 > li.is-hidden').removeClass('di_none');
				if(!($('.js-consumer-moreItem_5_5 > li.di_none').length)) {
					$(this).addClass('di_none');
				}
			});
			$('.js-consumer-moreItem_5_5 > li').waypoint(function(direction){
				var activePoint = $(this.element);
				if(direction === 'down') { // scroll down
					activePoint.addClass(a);
				} else { // scroll up
					activePoint.removeClass(a);
				}
			}, { offset : '70%' });
		}
		if($('.js-consumer-moreItem_17_15').length) {
			for (let i=0; i < $('.js-consumer-moreItem_17_15 > li').length; i++) {
				if(i < 17) {
					$('.js-consumer-moreItem_17_15 > li').eq(i).removeClass('di_none');
				}
			}
			$('.js-consumer-moreItem_17_15-button').removeClass('di_none');
			if($('.js-consumer-moreItem_17_15 > li').length < 18) {
				$('.js-consumer-moreItem_17_15-button').addClass('di_none');
			}
			$('.js-consumer-moreItem_17_15-button').on('click', function(){
				for (let i=0; i < $('.js-consumer-moreItem_17_15 > li.di_none').length; i++) {
					if(i < 15) {
						$('.js-consumer-moreItem_17_15 > li.di_none').eq(i).addClass('is-hidden');
					}
				}
				$('.js-consumer-moreItem_17_15 > li.is-hidden').removeClass('di_none');
				if(!($('.js-consumer-moreItem_17_15 > li.di_none').length)) {
					$(this).addClass('di_none');
				}
			});
			$('.js-consumer-moreItem_17_15 > li').waypoint(function(direction){
				var activePoint = $(this.element);
				if(direction === 'down') { // scroll down
					activePoint.addClass(a);
				} else { // scroll up
					activePoint.removeClass(a);
				}
			}, { offset : '70%' });
		}
	};
	const consumerLensesTop = () => {
		// ナビ部分 ------------------------
		if($('.js-consumer-lenses-top-filter-button').length) {
			const f = 'is-fixed';
			let scrollTopNow = 0;
			$('.js-consumer-lenses-top-filter-buttonWrap-sp .js-consumer-lenses-top-filter-button').on('click', function(){
				$('.js-consumer-lenses-top-filter-buttonWrap-sp .js-consumer-lenses-top-filter-button').toggleClass(a);
				$('.js-consumer-lenses-top-filter-block').toggleClass(a);
				// scrollTopNow = document.body.scrollTop + document.documentElement.scrollTop;
				$('.container').css({
					position: 'fixed',
					width: '100%',
					top: -1 * scrollTopNow,
					left: 0
				});
				$('body').addClass(f);
				setTimeout(() => {
					$('.js-consumer-lenses-top-filter-block').toggleClass(v);
				}, 100);
			});
			$('.js-consumer-lenses-top-filter-button-close').on('click', function(){
				$('.js-consumer-lenses-top-filter-buttonWrap-sp .js-consumer-lenses-top-filter-button').removeClass(a);
				$('.js-consumer-lenses-top-filter-block').removeClass(v);
				$('.container').css({
					position: 'static',
				});
				if ($('body').hasClass(f)) {
					$('body').removeClass(f);
					$(window).scrollTop(scrollTopNow);
				}
				setTimeout(() => {
					$('.js-consumer-lenses-top-filter-block').removeClass(a);
				}, 100);
			});
			$('.js-consumer-lenses-top-filter-overlay').on('click', function(){
				$('.js-consumer-lenses-top-filter-buttonWrap-sp .js-consumer-lenses-top-filter-button').removeClass(a);
				$('.js-consumer-lenses-top-filter-block').removeClass(v);
				$('.container').css({
					position: 'static',
				});
				if ($('body').hasClass(f)) {
					$('body').removeClass(f);
					$(window).scrollTop(scrollTopNow);
				}
				setTimeout(() => {
					$('.js-consumer-lenses-top-filter-block').removeClass(a);
				}, 100);
			});
			$('.js-consumer-lenses-top-filter-buttonWrap-pc .js-consumer-lenses-top-filter-button').on('click', function(){
				$('.js-consumer-lenses-top-filter-buttonWrap-pc .js-consumer-lenses-top-filter-button').toggleClass(a);
				$('.js-consumer-lenses-top-filter-block').toggleClass(a);
			});
		}
		// json出力部分 ------------------------
		if($('.js-consumer-lenses-top-json').length) {
			// 変数定義---------------------
			const serchBtn = $('.js-consumer-lenses-top-searchKeyword button');
			const serchInput = $('.js-consumer-lenses-top-searchKeyword input');
			const navInput = $('.js-consumer-lenses-top-nav-input input');
			// json定義---------------------
			const getJSONconsumerlensestop = () => {
				return $.getJSON(`/ajax/${lang}/consumer/product/lens.json`);
			};
			// html出力---------------------
			const addHTML = (_list) => {
				// console.log(_list,'json');
				let HTML = '';
				let categoryHead = '';
				for(let i = 0 ; i < _list.length ; i++) {
					// newアイコンだし分け
					let newIcon = '';
					if(_list[i].rt_cf_new) {
						newIcon = '<span class="consumer-newIcon-icon"><span class="">NEW</span></span>';
					}
					// $マウント名$出力
					let mountArea = '';
					if(_list[i].cf_p_mount) {
						if(_list[i].cf_p_mount.length) {
							let mountHead = '<div class="mod-news-item-top _center mod-spacer-16_8_p">';
							let mountBottom = '</div>';
							let mountList = [];
							_list[i].cf_p_mount.forEach((item, index) => {
								mountList.push(item);
							});
							mountList.sort( function(a,b) {
								return Number(a.cf_plm_mount_order) - Number(b.cf_plm_mount_order);
							});
							mountList.forEach((elem) => {
								if(elem.cf_plm_end_of_sale_flag == '0') {
									mountArea += '<div class="mod-news-item-top-category"><span class="mod-news-item-category _products">'+elem.cf_plm_mount_name+'</span></div>';
								}
							});
							if(mountArea) {
								mountArea = mountHead + mountArea + mountBottom;
							}
						}
					}
					// カテゴリブロック出力
					if(!(_list[i].rt_cf_pc_name.content === categoryHead)) {
						if(!(categoryHead == '')) {
							HTML += '</ul></div>';
						}
						HTML += '<div id="" class="consumer-lenses-top-body-item-content-block">'+
						'<h2 class="mod-head02 _left">'+
						'<span class="_main">'+_list[i].rt_cf_pc_name.content+'</span>'+
						'</h2>'+
						'<ul class="pure-g space-u-box mod-spacer-small_p">';
						categoryHead = _list[i].rt_cf_pc_name.content;
					}
					// 日英だし分け
					let more;
					if(lang === 'jp') {
						more = '<span>詳しくはこちら</span>';
					} else {
						more = '<span>Learn More</span>';
					}
					HTML += '<li data-key="'+_list[i]._key+'" class="pure-u-1-3 pure-u-md-1-2 space-u-box-child consumer-lenses-top-body-item-content-block-item js-consumer-lenses-top-json-item">'+
					'<a href="'+_list[i].rt_cf_p_href.href+'" class="di_block opacity">'+
					'<figure class="consumer-productsImg consumer-newIcon">'+
					'<img src="'+_list[i].rt_cf_p_thumb_img.src+'" alt="'+toAltText(_list[i].cf_p_title)+'" class="height-auto width-u-100" loading="lazy" width="600" height="600">'+
					newIcon+
					'</figure>'+
					'</a>'+
					'<div class="js-lead-block">'+
					'<p class="mod-head04 ta_center mod-spacer-16_8">'+
					'<span>'+_list[i].cf_p_title+'</span>'+
					'</p>'+
					'<p class="fw_medium ta_center mod-spacer-16_8">'+
					'<span>Model '+_list[i].rt_cf_pb_model_name.content+'</span>'+
					'</p>'+
					mountArea+
					'</div>'+
					'<div class="mod-spacer-24_16_p">'+
					'<a href="'+_list[i].rt_cf_p_href.href+'" target="" class="mod-button _border _300 _md_215">'+
					more+
					'</a>'+
					'</div>'+
					'</li>';
				}
				HTML += '</ul></div>';
				$('.js-consumer-lenses-top-json').append(HTML);
			};
			// urlパラメータ取得・チェックボックスチェック---------------------
			const paraCheck = () => {
				// URLパラメータを"&"で分離する
				let url_search = location.search.substring(1).split('&');
				// パラメータ連想配列エリア初期化
				let para = [];
				// キーエリア初期化
				let key = null;
				for(let i = 0 ; i < url_search.length ; i++) {
					// "&"で分離したパラメータを"="で再分離
					key = url_search[i].split("=");
					para.push([key[0],key[1]]);
				}
				para.forEach((paraElem) => {
					// チェックボックスチェック
					navInput.each( function( idx, elem ) {
						if((paraElem[0] == $(elem).attr('name')) && (paraElem[1].replaceAll("+"," ") == $(elem).val())) {
							$(elem).prop('checked', true);
							$(elem).parents('.js-toggleBlock').stop().slideDown(400);
							$(elem).parents('.js-toggleBlock').prev('.js-toggle').addClass('is-active');
						}
					});
					// キーワード入力チェック
					serchInput.each( function( idx, elem ) {
						if(paraElem[0] == $(elem).attr('name')) {
							$(elem).val(decodeURIComponent(paraElem[1]).replaceAll("+"," "));
						}
					});
				});
			};
			// フィルタリング関数---------------------
			// キーワード・チェックボックス・ラジオボタンフィルタリング
			const filterList = (data) => {
				// リストから販売終了製品を除外
				const EndofSaleExclusionListArray = [];
				data.rt_bn_consumer_lens_list.forEach((item, index) => {
					if(item.cf_p_mount) {
						if(item.cf_p_mount.length) {
							const count = item.cf_p_mount.filter( function(value) {
								return value.cf_plm_end_of_sale_flag == '1';
							}).length;
							if(!(count == item.cf_p_mount.length)) {
								EndofSaleExclusionListArray.push(index);
							}
						} else {
							// EndofSaleExclusionListArray.push(index);
						}
					} else {
						// EndofSaleExclusionListArray.push(index);
					}
				});
				const EndofSaleExclusionList = EndofSaleExclusionListArray.map(
					(index) => data.rt_bn_consumer_lens_list[index]
				);
				console.log(EndofSaleExclusionList,'EndofSaleExclusionList');
				// チェックボックスに対するフィルタリングされたデータ
				const filteredDataCheckbox = {
					lens_mount: [],
					sensor_size: [],
					lens_type: [],
					genre: [],
				};
				const filteredDataRadio = {
					utility: [],
				};
				const filterdKeyword = {
					pc_search_keyword: [],
					sp_search_keyword: [],
				}
				Object.keys(filteredDataCheckbox).forEach((pt_group_code) => {
					const checkedValueList = Array.from(
						document.querySelectorAll(`[name=${pt_group_code}]:checked`)
					).map((checked) => checked.value);
			
					EndofSaleExclusionList.forEach((item, index) => {
						if((pt_group_code === 'lens_type') || (pt_group_code === 'genre')) {
							if(item.cf_p_tags) {
								const foundItem = item.cf_p_tags.find(
									(tag) => tag.cf_pt_group_code == pt_group_code
								);
								// console.log(checkedValueList,'checkedValueList');
								if (checkedValueList.length > 0) {
									// console.log(foundItem,'foundItem');
									if (foundItem) {
										const isExists = checkedValueList.includes(foundItem._key);
										// console.log(isExists,'isExists');
										if (isExists) {
											filteredDataCheckbox[pt_group_code].push(index);
										}
									}
								} else {
									filteredDataCheckbox[pt_group_code].push(index);
								}
							}
						} else if(pt_group_code === 'sensor_size') {
							if(item.cf_p_mount) {
								if(item.cf_p_mount.length) {
									if (checkedValueList.length > 0) {
										checkedValueList.forEach((elem) => {
											// console.log(elem,'elem');
											let keyName = '';
											if(elem === 'full_frame') {
												keyName = 'cf_plm_sensor_size_full';
											}
											if(elem === 'aps_c') {
												keyName = 'cf_plm_sensor_size_aps_c';
											}
											if(elem === 'four-thirds') {
												keyName = 'cf_plm_sensor_size_four_thirds';
											}
											const found = item.cf_p_mount.find(
												(mount) => mount[keyName] && mount[keyName] == '1'
											);
											// console.log(found,'found');
											if(found) {
												filteredDataCheckbox[pt_group_code].push(index);
												return false;
											}
										});
									} else {
										filteredDataCheckbox[pt_group_code].push(index);
									}
								} else {
									filteredDataCheckbox[pt_group_code].push(index);
								}
							} else {
								filteredDataCheckbox[pt_group_code].push(index);
							}
						} else if((pt_group_code === 'lens_mount')) {
							if(item.cf_p_mount) {
								if(item.cf_p_mount.length) {
									if (checkedValueList.length > 0) {
										checkedValueList.forEach((elem) => {
											console.log(elem,'elem');
											const found = item.cf_p_mount.find(
												(mount) => (mount.cf_plm_end_of_sale_flag == '0') && (mount.cf_plm_mount_name) && (mount.cf_plm_mount_name == elem)
											);
											console.log(found,'found');
											if(found) {
												filteredDataCheckbox[pt_group_code].push(index);
												return false;
											}
										});
									} else {
										filteredDataCheckbox[pt_group_code].push(index);
									}
								} else {
									filteredDataCheckbox[pt_group_code].push(index);
								}
							} else {
								filteredDataCheckbox[pt_group_code].push(index);
							}
						}
					});
				});
				Object.keys(filteredDataRadio).forEach((pt_group_code) => {
					const checkedObj = document.querySelector(
						`[name=${pt_group_code}]:checked`
					);
					EndofSaleExclusionList.forEach((item, index) => {
						if (item.cf_p_tags) {
							const foundItem = item.cf_p_tags.find(
								(tag) => tag.cf_pt_group_code == pt_group_code
							);
							if (!checkedObj || (checkedObj && !checkedObj.value)) {
								filteredDataRadio[pt_group_code].push(index);
							} else {
								if (foundItem) {
								const isExists = checkedObj.value == foundItem._key;
								if (isExists) {
									filteredDataRadio[pt_group_code].push(index);
								}
								}
							}
						}
					});
				});
				Object.keys(filterdKeyword).forEach((search_keyword) => {
					const searchObj = document.querySelector(
						`[name=${search_keyword}]`
					);
					const joinedData = EndofSaleExclusionList.map((item, index) => {
						const cf_p_spe_f = _.get(item, "cf_p_spe_f");
						const cf_p_spec_1 = _.get(item, "cf_p_spec_1");
						const cf_p_title = _.get(item, "cf_p_title");
						const rt_cf_pb_model_name = _.get(item, "rt_cf_pb_model_name.content");
						const _key = _.get(item, "_key");
						let cf_plm_mount_name = '';
						if(item.cf_p_mount) {
							if(item.cf_p_mount.length) {
								item.cf_p_mount.forEach((elem) => {
									if(elem.cf_plm_end_of_sale_flag == '0') {
										cf_plm_mount_name += (elem.cf_plm_mount_name +' ');
									}
								});
							}
						}
						const concatStr = `${cf_p_spe_f || ""} ${cf_p_spec_1 || ""} ${
						  cf_p_title || ""
						} ${rt_cf_pb_model_name || ""} ${_key || ""} ${cf_plm_mount_name || ""}`;
						return concatStr;
					});
					joinedData.forEach((item, index) => {
						if(!searchObj || (searchObj && !searchObj.value)) {
							filterdKeyword[search_keyword].push(index);
						} else {
							item.indexOf(searchObj.value) !== -1 && filterdKeyword[search_keyword].push(index);
						}
					});
				});
				// console.log(filteredDataCheckbox,'filteredDataCheckbox');
				const selectedItemIndexList = _.intersection(
					..._.values(filteredDataCheckbox),
					..._.values(filteredDataRadio),
					..._.values(filterdKeyword),
				);
				// console.log(selectedItemIndexList,'selectedItemIndexList');
				const resultItemList = selectedItemIndexList.map(
					(index) => EndofSaleExclusionList[index]
				);
				return resultItemList;
			};
			// フィルタリング---------------------
			const listFilter = (_data) => {
				// 初期化
				$('.js-consumer-lenses-top-json').addClass('is-loading');
				$('.js-consumer-lenses-top-json-item').removeClass('is-active');
				$('.js-consumer-lenses-top-json-num').html('');
				// チェックされた要素のパラメータ追加
				const urlSearchParams = new URLSearchParams('');
				$('.js-consumer-lenses-top-nav-input input:checked').each( function( idx, elem ) {
					// console.log($(elem),$(elem).attr('name'), $(elem).val(),'inputchecked');
					urlSearchParams.append($(elem).attr('name'), $(elem).val());
				});
				// 入力されたキーワードパラメータ追加
				serchInput.each( function( idx, elem ) {
					// console.log($(elem),$(elem).attr('name'), $(elem).val(),'inputchecked');
					urlSearchParams.append($(elem).attr('name'), $(elem).val());
				});
				history.replaceState("", "", `?${urlSearchParams.toString()}`);
				// フィルタリング
				let filterListArray = filterList(_data);
				for(let i = 0 ; i < filterListArray.length; i++) {
					$('.js-consumer-lenses-top-json-item').each( function( idx, elem ) {
						if($(elem).data('key') == filterListArray[i]._key) {
							$(elem).addClass('is-active');
						}
					});
				}
				// ブロック表示
				for(let j = 0 ; j < $('.consumer-lenses-top-body-item-content-block').length; j++) {
					if(!($('.consumer-lenses-top-body-item-content-block').eq(j).find('.is-active').length)) {
						$('.consumer-lenses-top-body-item-content-block').eq(j).addClass('di_none');
					} else {
						$('.consumer-lenses-top-body-item-content-block').eq(j).removeClass('di_none');
					}
				}
				// jsonエリア表示
				setTimeout(() => {
					$('.js-consumer-lenses-top-json').removeClass('is-loading');
				}, 300);
				// item数表示
				$('.js-consumer-lenses-top-json-num').html(filterListArray.length);
				// matchheight
				$('.js-consumer-lenses-top-json-item.is-active .mod-head04').matchHeight();
				$('.js-consumer-lenses-top-json-item.is-active .js-lead-block').matchHeight();
				$('html,body').stop().animate({ scrollTop: 0 }, 1200, 'easeOutExpo');
			};
			// json出力・イベント---------------------
			getJSONconsumerlensestop().done((data) => {
				// urlパラメータチェック・チェックボックスチェック
				paraCheck();
				// フィルタリング
				addHTML(data.rt_bn_consumer_lens_list);
				listFilter(data);
				serchBtn.on('click', function () {
					listFilter(data);
				});
				if(!($(window).width() < 1025)) {
					serchInput.keypress(function(e){
						if(e.which === 13) {
							listFilter(data);
							return false;
						}
					});
				}
				navInput.on('change', function () {
					listFilter(data);
				});
				// クリアボタン
				$('.js-consumer-lenses-top-filter-clear').on('click', function(){
					$('input[type="text"]').val('');
					$('input').prop('checked', false);
					$('.js-consumer-lenses-top-nav-utility').prop('checked', true);
					listFilter(data);
				});
			});
			window.addEventListener('pageshow',()=>{
				// $('input[type="text"]').val('');
				// $('input').prop('checked', false);
				// $('.js-consumer-lenses-top-nav-utility').prop('checked', true);
				if(window.performance.navigation.type==2) location.reload();
			});
		}
	};
	const consumerSearch = () => {
		// json出力部分 ------------------------
		if($('.js-consumer-search-json').length) {
			// 変数定義---------------------
			const serchBtn = $('.js-consumer-search-searchKeyword button');
			const serchInput = $('.js-consumer-search-searchKeyword input');
			// json定義---------------------
			const getJSONconsumerSearch = () => {
				return $.getJSON(`/ajax/${lang}/consumer/product/all.json`);
			};
			// html出力---------------------
			const addHTML = (_list) => {
				// console.log(_list,'json');
				let HTML = '';
				for(let i = 0 ; i < _list.length ; i++) {
					// newアイコンだし分け
					let newIcon = '';
					if(_list[i].rt_cf_new) {
						newIcon = '<span class="consumer-newIcon-icon"><span class="">NEW</span></span>';
					}
					// $マウント名$出力
					let mountArea = '';
					if(_list[i].cf_p_mount) {
						if(_list[i].cf_p_mount.length) {
							let mountHead = '<div class="mod-news-item-top _center mod-spacer-16_8_p">';
							let mountBottom = '</div>';
							let mountList = [];
							_list[i].cf_p_mount.forEach((item, index) => {
								mountList.push(item);
							});
							mountList.sort( function(a,b) {
								return Number(a.cf_plm_mount_order) - Number(b.cf_plm_mount_order);
							});
							mountList.forEach((elem) => {
								if(elem.cf_plm_end_of_sale_flag == '0') {
									mountArea += '<div class="mod-news-item-top-category"><span class="mod-news-item-category _products">'+elem.cf_plm_mount_name+'</span></div>';
								}
							});
							if(mountArea) {
								mountArea = mountHead + mountArea + mountBottom;
							}
						}
					}
					// 対応レンズ
					let supportLens = '';
					if(_list[i].cf_p_support_lens) {
						if(_list[i].cf_p_support_lens.length) {
							if(lang === 'jp') {
								supportLens += '<div class="mod-spacer-24_16_p"><div class="mod-news-item-top"><div class="mod-news-item-top-category"><span class="mod-news-item-category _pickup">対応レンズ</span></div></div><ul class="ul-disc fs_14 fs_md_12">';
							} else {
								supportLens += '<div class="mod-spacer-24_16_p"><div class="mod-news-item-top"><div class="mod-news-item-top-category"><span class="mod-news-item-category _pickup">Compatible Lenses</span></div></div><ul class="ul-disc fs_14 fs_md_12">';
							}
							for(let l = 0 ; l < _list[i].cf_p_support_lens.length ; l++) {
								if(_list[i].cf_p_support_lens[l].cf_p_status == '1') {
									supportLens += '<li>'+_list[i].cf_p_support_lens[l].cf_p_title+'</li>';
								}
							}
							supportLens += '</ul></div>';
						}
					}
					// 備考
					let remarks = '';
					if((_list[i].cf_pb_category)) {
						if((_list[i].cf_pb_category.cf_pc_code)) {
							if((_list[i].cf_pb_category.cf_pc_code === 'cable') && (_list[i].cf_pb_category.cf_pc_group_code === 'accessories')) {
								remarks = '<div class="mod-spacer-16_8_p"><p class="fs_14 fs_md_12">'+_list[i].cf_p_remks+'</p></div>';
							}
						}
					}
					// リンク
					let link = '';
					if((_list[i].cf_pb_category)) {
						if((_list[i].cf_pb_category.cf_pc_code)) {
							if(!(_list[i].cf_pb_category.cf_pc_group_code === 'accessories')) {
								link = '<a href="'+_list[i].rt_cf_p_href.href+'" class="di_block mod-link-bule_p opacity">'+
								'<figure class="consumer-productsImg consumer-newIcon">'+
								'<img src="'+_list[i].rt_cf_p_thumb_img.src+'" alt="'+toAltText(_list[i].cf_p_title)+'" class="height-auto width-u-100" loading="lazy" width="600" height="600">'+
								newIcon+
								'</figure>'+
								'</a>';
							} else {
								link = '<figure class="consumer-productsImg consumer-newIcon">'+
								'<img src="'+_list[i].rt_cf_p_thumb_img.src+'" alt="'+toAltText(_list[i].cf_p_title)+'" class="height-auto width-u-100" loading="lazy" width="600" height="600">'+
								newIcon+
								'</figure>';
							}
						} else {
							link = '<figure class="consumer-productsImg consumer-newIcon">'+
							'<img src="'+_list[i].rt_cf_p_thumb_img.src+'" alt="'+toAltText(_list[i].cf_p_title)+'" class="height-auto width-u-100" loading="lazy" width="600" height="600">'+
							newIcon+
							'</figure>';
						}
					} else {
						link = '<figure class="consumer-productsImg consumer-newIcon">'+
						'<img src="'+_list[i].rt_cf_p_thumb_img.src+'" alt="'+toAltText(_list[i].cf_p_title)+'" class="height-auto width-u-100" loading="lazy" width="600" height="600">'+
						newIcon+
						'</figure>';
					}
					
					// 詳しくはこちら
					let more;
					let onlineText;
					if(lang === 'jp') {
						more = '<span>詳しくはこちら</span>';
						onlineText ='<span>オンラインショップで購入</span>';
					} else {
						more = '<span>Learn More</span>';
						onlineText ='<span>Online Shop</span>';
					}
					// オンラインショップリンク
					let onlineShopLink = '';
					if(_list[i].cf_p_online_url) {
						if(!(_list[i].cf_pb_category.cf_pc_group_code === 'accessories')) {
							onlineShopLink = '<div class="mod-spacer-24_16_p">'+
							'<a href="'+_list[i].rt_cf_p_href.href+'" target="" class="mod-button _border _300 _md_215">'+
							more+
							'</a>'+
							'</div>';
						} else {
							if(lang === 'jp') {
								if(_list[i].cf_p_online_url) {
									onlineShopLink = '<div class="mod-spacer-24_16_p">'+
									'<a href="'+_list[i].cf_p_online_url+'" target="_blank" class="mod-button _border _300 _md_215">'+
									onlineText+
									'</a>'+
									'</div>';
								}
							}
						}
					} else {
						if(!(_list[i].cf_pb_category.cf_pc_group_code === 'accessories')) {
							onlineShopLink = '<div class="mod-spacer-24_16_p">'+
							'<a href="'+_list[i].rt_cf_p_href.href+'" target="" class="mod-button _border _300 _md_215">'+
							more+
							'</a>'+
							'</div>';
						}
					}
					HTML += '<li data-key="'+_list[i]._key+'" class="pure-u-1-3 pure-u-md-1-1 space-u-box-child js-consumer-search-json-item">'+
					link+
					'<p class="mod-head04 ta_center mod-spacer-16_8">'+
						'<span>'+_list[i].cf_p_title+'</span>'+
					'</p>'+
					'<div class="js-lead-block">'+
					'<p class="fw_medium ta_center mod-spacer-16_8">'+
					'<span>Model '+_list[i].rt_cf_pb_model_name.content+'</span>'+
					'</p>'+
					mountArea+
					supportLens+
					remarks+
					'</div>'+
					onlineShopLink+
					'</li>';
				}
				$('.js-consumer-search-json').append(HTML);
			};
			// urlパラメータ取得・チェックボックスチェック---------------------
			const paraCheck = () => {
				// URLパラメータを"&"で分離する
				let url_search = location.search.substring(1).split('&');
				// パラメータ連想配列エリア初期化
				let para = [];
				// キーエリア初期化
				let key = null;
				for(let i = 0 ; i < url_search.length ; i++) {
					// "&"で分離したパラメータを"="で再分離
					key = url_search[i].split("=");
					para.push([key[0],key[1]]);
				}
				para.forEach((paraElem) => {
					// キーワード入力チェック
					serchInput.each( function( idx, elem ) {
						if(paraElem[0] == $(elem).attr('name')) {
							// let keywordvalbefor = decodeURIComponent(paraElem[1]).replaceAll(/[\"]/g,"").replaceAll(/[\']/g,"");
							// let keywordVal = keywordvalbefor.normalize("NFKC");
							let keywordval = decodeURIComponent(paraElem[1]).replaceAll("+"," ");
							$(elem).val(keywordval);
						}
					});
				});
			};
			// フィルタリング関数---------------------
			// キーワード・チェックボックス・ラジオボタンフィルタリング
			const filterList = (data) => {
				// リストから販売終了製品を除外
				const EndofSaleExclusionListArray = [];
				data.rt_bn_consumer_product_list.forEach((item, index) => {
					if((item.cf_pb_category)) {
						if((item.cf_pb_category.cf_pc_group_code === "lenses")) {
							if(item.cf_p_mount) {
								if(item.cf_p_mount.length) {
									const count = item.cf_p_mount.filter( function(value) {
										return value.cf_plm_end_of_sale_flag == '1';
									}).length;
									if(!(count == item.cf_p_mount.length)) {
										EndofSaleExclusionListArray.push(index);
									}
								} else {
									// EndofSaleExclusionListArray.push(index);
								}
							} else {
								// EndofSaleExclusionListArray.push(index);
							}
						} else {
							EndofSaleExclusionListArray.push(index);
						}
					} else {
						EndofSaleExclusionListArray.push(index);
					}
				});
				const EndofSaleExclusionList = EndofSaleExclusionListArray.map(
					(index) => data.rt_bn_consumer_product_list[index]
				);
				// console.log(EndofSaleExclusionList,'EndofSaleExclusionList');
				const filterdKeyword = {
					search_keyword: [],
				}
				Object.keys(filterdKeyword).forEach((search_keyword) => {
					const searchObj = document.querySelector(
						`[name=${search_keyword}]`
					);
					const joinedData = EndofSaleExclusionList.map((item, index) => {
						const cf_p_spe_f = _.get(item, "cf_p_spe_f");
						const cf_p_spec_1 = _.get(item, "cf_p_spec_1");
						const cf_p_title = _.get(item, "cf_p_title");
						const rt_cf_pb_model_name = _.get(item, "rt_cf_pb_model_name.content");
						const _key = _.get(item, "_key");
						let cf_plm_mount_name = '';
						if(item.cf_p_mount) {
							if(item.cf_p_mount.length) {
								item.cf_p_mount.forEach((elem) => {
									if(elem.cf_plm_end_of_sale_flag == '0') {
										cf_plm_mount_name += (elem.cf_plm_mount_name +' ');
									}
								});
							}
						}
						const concatStr = `${cf_p_spe_f || ""} ${cf_p_spec_1 || ""} ${
						  cf_p_title || ""
						} ${rt_cf_pb_model_name || ""} ${_key || ""} ${cf_plm_mount_name || ""}`;
						return concatStr;
					});
					joinedData.forEach((item, index) => {
						if(!searchObj || (searchObj && !searchObj.value)) {
							filterdKeyword[search_keyword].push(index);
						} else {
							item.indexOf(searchObj.value) !== -1 && filterdKeyword[search_keyword].push(index);
						}
					});
				});
				const selectedItemIndexList = _.intersection(
					..._.values(filterdKeyword),
				);
				const resultItemList = selectedItemIndexList.map(
					(index) => EndofSaleExclusionList[index]
				);
				return resultItemList;
			};
			// フィルタリング---------------------
			const listFilter = (_data) => {
				// 初期化
				$('.js-consumer-search-json').addClass('is-loading');
				$('.js-consumer-search-json-item').removeClass('is-active');
				$('.js-consumer-search-json-num').html('');
				// チェックされた要素のパラメータ追加
				const urlSearchParams = new URLSearchParams('');
				// 入力されたキーワードパラメータ追加
				serchInput.each( function( idx, elem ) {
					// console.log($(elem),$(elem).attr('name'), $(elem).val(),'inputchecked');
					urlSearchParams.append($(elem).attr('name'), $(elem).val());
				});
				history.replaceState("", "", `?${urlSearchParams.toString()}`);
				// フィルタリング
				let filterListArray = filterList(_data);
				for(let i = 0 ; i < filterListArray.length; i++) {
					$('.js-consumer-search-json-item').each( function( idx, elem ) {
						if($(elem).data('key') == filterListArray[i]._key) {
							$(elem).addClass('is-active');
						}
					});
				}
				// jsonエリア表示
				setTimeout(() => {
					$('.js-consumer-search-json').removeClass('is-loading');
				}, 300);
				// item数表示
				$('.js-consumer-search-json-num').html(filterListArray.length);
				// matchheight
				$('.js-consumer-search-json-item.is-active .mod-head04').matchHeight();
				$('.js-consumer-search-json-item.is-active .js-lead-block').matchHeight();
			};
			// json出力・イベント---------------------
			getJSONconsumerSearch().done((data) => {
				// urlパラメータチェック・チェックボックスチェック
				paraCheck();
				// フィルタリング
				addHTML(data.rt_bn_consumer_product_list);
				listFilter(data);
				serchBtn.on('click', function () {
					listFilter(data);
				});
				if(!($(window).width() < 1025)) {
					serchInput.keypress(function(e){
						if(e.which === 13) {
							listFilter(data);
							return false;
						}
					});
				}
			});
		}
	};
	const consumerTop = () => {
		if($('.js-consumer-top-search').length) {
			const serchInput = $('.js-consumer-top-search input');
			if(!($(window).width() < 1025)) {
				serchInput.keypress(function(e){
					if(e.which === 13) {
						$('form').submit();
						return false;
					}
				});
			}
		}
		if($('.js-consumer-top-pickup').length) {
			let HTML = '';
			const getJSONpickup = (_id) => {
				return $.getJSON(`/ajax/${lang}/consumer/article_info/${_id}.json`);
			};
			if(!$('.js-consumer-top-pickup').length) {
				$('.js-consumer-top-pickupWrap').addClass('di_none');
			} else {
				for(let i = 0 ; i < $('.js-consumer-top-pickup').length; i++) {
					getJSONpickup($('.js-consumer-top-pickup').eq(i).find('.js-consumer-top-pickup-id').text()).done((data) => {
						// console.log(data.rt_bn_article_info[0],'data');
						if(data.rt_bn_article_info[0].rt_cf_ac_code.content == 'campaign') {
							HTML = '<a href="'+data.rt_bn_article_info[0].rt_cf_a_href_campaign.href+'" target="'+data.rt_bn_article_info[0].rt_cf_a_href_campaign.target+'" class="di_block mod-link-zoom mod-link-bule_p">'+
							'<figure>'+
							'<img src="'+data.rt_bn_article_info[0].rt_cf_a_thum_img.src+'" alt="'+data.rt_bn_article_info[0].rt_cf_a_title.content[0]+'" class="height-auto width-u-100 _zoom_img rt_cf_a_thum_img" loading="lazy" width="750" height="500">'+
							'</figure>'+
							'<div class="mod-news-item-top mod-spacer-16_8_p">'+
							'<div class="mod-news-item-top-category">'+
							'<span class="mod-news-item-category _pickup">'+data.rt_bn_article_info[0].rt_cf_ac_name.content+'</span>'+
							'</div>'+
							'</div>'+
							'<div class="mod-spacer-16_8">'+
							'<p class="fw_medium mt8 rt_cf_a_title">'+data.rt_bn_article_info[0].rt_cf_a_title.content[0]+'</p>'+
							'</div>'+
							'</a>';
						} else if(data.rt_bn_article_info[0].rt_cf_ac_code.content == 'sp_contents') {
							HTML = '<a href="'+data.rt_bn_article_info[0].rt_cf_a_href_sp_contents.href+'" target="'+data.rt_bn_article_info[0].rt_cf_a_href_sp_contents.target+'" class="di_block mod-link-zoom mod-link-bule_p">'+
							'<figure>'+
							'<img src="'+data.rt_bn_article_info[0].rt_cf_a_thum_img.src+'" alt="'+data.rt_bn_article_info[0].rt_cf_a_title.content[0]+'" class="height-auto width-u-100 _zoom_img rt_cf_a_thum_img" loading="lazy" width="750" height="500">'+
							'</figure>'+
							'<div class="mod-news-item-top mod-spacer-16_8_p">'+
							'<div class="mod-news-item-top-category">'+
							'<span class="mod-news-item-category _pickup">'+data.rt_bn_article_info[0].rt_cf_ac_name.content+'</span>'+
							'</div>'+
							'</div>'+
							'<div class="mod-spacer-16_8">'+
							'<p class="fw_medium mt8 rt_cf_a_title">'+data.rt_bn_article_info[0].rt_cf_a_title.content[0]+'</p>'+
							'</div>'+
							'</a>';
						} else if(data.rt_bn_article_info[0].rt_cf_ac_code.content == 'contest') {
							HTML = '<a href="'+data.rt_bn_article_info[0].rt_cf_a_href_contest.href+'" target="'+data.rt_bn_article_info[0].rt_cf_a_href_contest.target+'" class="di_block mod-link-zoom mod-link-bule_p">'+
							'<figure>'+
							'<img src="'+data.rt_bn_article_info[0].rt_cf_a_thum_img.src+'" alt="'+data.rt_bn_article_info[0].rt_cf_a_title.content[0]+'" class="height-auto width-u-100 _zoom_img rt_cf_a_thum_img" loading="lazy" width="750" height="500">'+
							'</figure>'+
							'<div class="mod-news-item-top mod-spacer-16_8_p">'+
							'<div class="mod-news-item-top-category">'+
							'<span class="mod-news-item-category _pickup">'+data.rt_bn_article_info[0].rt_cf_ac_name.content+'</span>'+
							'</div>'+
							'</div>'+
							'<div class="mod-spacer-16_8">'+
							'<p class="fw_medium mt8 rt_cf_a_title">'+data.rt_bn_article_info[0].rt_cf_a_title.content[0]+'</p>'+
							'</div>'+
							'</a>';
						} else if(data.rt_bn_article_info[0].rt_cf_ac_code.content == 'photo') {
							if(data.rt_bn_article_info[0].rt_cf_a_zoom_mark) {
								HTML = '<a href="'+data.rt_bn_article_info[0].rt_cf_a_thum_img.src+'" target="_blank" class="di_block mod-link-zoom mod-link-bule_p">'+
								'<figure class="mod-link-icon-modal">'+
								'<img src="'+data.rt_bn_article_info[0].rt_cf_a_thum_img.src+'" alt="'+data.rt_bn_article_info[0].rt_cf_a_title.content[0]+'" class="height-auto width-u-100 _zoom_img rt_cf_a_thum_img" loading="lazy" width="750" height="500"><svg class="rt_cf_a_example_is_not"><use xlink:href="/common/svg/sprite.svg#zoom"></use></svg>'+
								'</figure>'+
								'<div class="mod-news-item-top mod-spacer-16_8_p">'+
								'<div class="mod-news-item-top-category">'+
								'<span class="mod-news-item-category _pickup">'+data.rt_bn_article_info[0].rt_cf_ac_name.content+'</span>'+
								'</div>'+
								'</div>'+
								'<div class="mod-spacer-16_8">'+
								'<p class="fw_medium mt8 rt_cf_a_title">'+data.rt_bn_article_info[0].rt_cf_a_title.content[0]+'</p>'+
								'</div>'+
								'</a>';
							} else {
								HTML = '<figure class="">'+
								'<img src="'+data.rt_bn_article_info[0].rt_cf_a_thum_img.src+'" alt="'+data.rt_bn_article_info[0].rt_cf_a_title.content[0]+'" class="height-auto width-u-100 _zoom_img rt_cf_a_thum_img" loading="lazy" width="750" height="500"></figure>'+
								'<div class="mod-news-item-top mod-spacer-16_8_p">'+
								'<div class="mod-news-item-top-category">'+
								'<span class="mod-news-item-category _pickup">'+data.rt_bn_article_info[0].rt_cf_ac_name.content+'</span>'+
								'</div>'+
								'</div>'+
								'<div class="mod-spacer-16_8">'+
								'<p class="fw_medium mt8 rt_cf_a_title">'+data.rt_bn_article_info[0].rt_cf_a_title.content[0]+'</p>'+
								'</div>';
							}
						} else if(data.rt_bn_article_info[0].rt_cf_ac_code.content == 'impression') {
							HTML = '<a href="'+data.rt_bn_article_info[0].rt_cf_a_href_impression.href+'" class="di_block mod-link-zoom mod-link-bule_p">'+
							'<figure>'+
							'<img src="'+data.rt_bn_article_info[0].rt_cf_a_thum_img.src+'" alt="'+data.rt_bn_article_info[0].rt_cf_a_title.content[0]+'" class="height-auto width-u-100 _zoom_img rt_cf_a_thum_img" loading="lazy" width="750" height="500">'+
							'</figure>'+
							'<div class="mod-news-item-top mod-spacer-16_8_p">'+
							'<div class="mod-news-item-top-category">'+
							'<span class="mod-news-item-category _pickup">'+data.rt_bn_article_info[0].rt_cf_ac_name.content+'</span>'+
							'</div>'+
							'</div>'+
							'<div class="mod-spacer-16_8">'+
							'<p class="fw_medium mt8 rt_cf_a_title">'+data.rt_bn_article_info[0].rt_cf_a_title.content[0]+'</p>'+
							'</div>'+
							'</a>';
						} else if(data.rt_bn_article_info[0].rt_cf_ac_code.content == 'video') {
							HTML = '<a href="'+data.rt_bn_article_info[0].rt_cf_a_image_video_url.href+'" target="_blank" class="di_block mod-link-zoom mod-link-bule_p rt_cf_a_image_video_url">'+
							'<figure class="mod-link-icon-movie">'+
							'<img src="'+data.rt_bn_article_info[0].rt_cf_a_thum_img.src+'" alt="'+data.rt_bn_article_info[0].rt_cf_a_title.content[0]+'" class="height-auto width-u-100 _zoom_img rt_cf_a_thum_img" loading="lazy" width="750" height="500">'+
							'<svg class=""><use xlink:href="/common/svg/sprite.svg#movie"></use></svg>'+
							'</figure>'+
							'<div class="mod-news-item-top mod-spacer-16_8_p">'+
							'<div class="mod-news-item-top-category">'+
							'<span class="mod-news-item-category _pickup">'+data.rt_bn_article_info[0].rt_cf_ac_name.content+'</span>'+
							'</div>'+
							'</div>'+
							'<div class="mod-spacer-16_8">'+
							'<p class="fw_medium rt_cf_a_image_video_title">'+data.rt_bn_article_info[0].rt_cf_a_title.content[0]+'</p>'+
							'</div>'+
							'</a>';
						}
						$('.js-consumer-top-pickup').eq(i).append(HTML);
					});
				}
			}
		}
	};
	const consumerLensesDiscontinued = () => {
		if($('.js-consumer-lenses-discontinued-tr').length) {
			let proName = '';
			let count = -1;
			for(let i = 0 ; i < $('.js-consumer-lenses-discontinued-tr').length; i++) {
				if(!(proName === $('.js-consumer-lenses-discontinued-tr').eq(i).find('td').eq(0).find('.rt_cf_key').text())) {
					proName = $('.js-consumer-lenses-discontinued-tr').eq(i).find('td').eq(0).find('.rt_cf_key').text();
					count += 1;
				} else {
					$('.js-consumer-lenses-discontinued-tr').eq(i).find('td').eq(0).addClass('di_none');
					$('.js-consumer-lenses-discontinued-tr').eq(i).find('td').eq(1).addClass('di_none');
					$('.js-consumer-lenses-discontinued-tr').eq(i).find('td').eq(2).addClass('di_none');
				}
				$('.js-consumer-lenses-discontinued-tr').eq(i).addClass('js-consumer-lenses-discontinued-tr-'+count);
			}
			for(let l = 0 ; l < (count + 1); l++) {
				$('.js-consumer-lenses-discontinued-tr-'+l+'').eq(0).find('td').eq(0).attr("rowspan", $('.js-consumer-lenses-discontinued-tr-'+l+'').length);
				$('.js-consumer-lenses-discontinued-tr-'+l+'').eq(0).find('td').eq(1).attr("rowspan", $('.js-consumer-lenses-discontinued-tr-'+l+'').length);
				$('.js-consumer-lenses-discontinued-tr-'+l+'').eq(0).find('td').eq(2).attr("rowspan", $('.js-consumer-lenses-discontinued-tr-'+l+'').length);
			}
		}
	};
	const consumerSpImpressionDetail = () => {
		if($('.js-consumer-sp-impression-detail-item').length) {
			for(let i = 0 ; i < $('.js-consumer-sp-impression-detail-item').length; i++) {
				const getJSONmodel = (_id) => {
					return $.getJSON(`/ajax/consumer/sp/impression/detail/${_id}.json`);
				};
				getJSONmodel($('.js-consumer-sp-impression-detail-item').eq(i).find('.js-consumer-sp-impression-detail-item-id').text()).done((data) => {
					$('.js-consumer-sp-impression-detail-item').eq(i).find('.js-consumer-sp-impression-detail-item-model').text(data.rt_bn_base[0].cf_pb_model_name);
				});
			}
		}
	};
	const consumerAccessories = () => {
		if($('.js-consumerAccessories').length) {
			let count = 0;
			for(let i = 0 ; i < $('.js-consumerAccessories').length; i++) {
				const getJSONAccessories = (_id) => {
					return $.getJSON(`/ajax/${lang}/consumer/lens/${_id}/related_accessory_detail.json`);
				};
				getJSONAccessories($('.js-consumerAccessories').eq(i).find('.rt_cf_p_id_related_accessory').text()).done((data) => {
					// console.log(data.rt_bn_product_info[0],'data',$('.js-consumerAccessories').eq(i).find('.rt_cf_p_id_related_accessory').text());
					// let Link = '/jp/consumer/accessories/'+data.rt_bn_product_info[0].cf_pb_category.cf_pc_code+'/#'+data.rt_bn_product_info[0]._key;
					// $('.js-consumerAccessories').eq(i).find('._link').attr('href',Link);
					if(data.rt_bn_product_info[0].cf_pb_category) {
						if(!(data.rt_bn_product_info[0].cf_pb_category.cf_pc_code === 'cables')) {
							if(data.rt_bn_product_info[0].cf_p_support_lens) {
								if(data.rt_bn_product_info[0].cf_p_support_lens.length) {
									data.rt_bn_product_info[0].cf_p_support_lens.forEach((elem) => {
										$('.js-consumerAccessories').eq(i).find('._list').append('<li><a href="/jp/consumer/lenses/'+elem._key+'/" class="_link"><span class="">'+elem.cf_p_title+'</span></a></li>');
									});
									$('.js-consumerAccessories').eq(i).find('.if_not_cable').removeClass('di_none');
								}
							}
						} else {
							$('.js-consumerAccessories').eq(i).find('.if_cable').removeClass('di_none');
						}
					}
					count += 1;
					// console.log(count , $('.js-consumerAccessories').length);
					if(count == $('.js-consumerAccessories').length) {
						if($('.consumer-detail-slide01').length) {
							$('.consumer-detail-slide01').slick({
								autoplay: false,
								slidesToShow: 3,
								slidesToScroll: 1,
								dots: false,
								infinite: true,
								arrows: true,
								prevArrow: '<a class="slick-prev" href="#"><svg class="slick-arrow_img"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>',
								nextArrow: '<a class="slick-next" href="#"><svg class="slick-arrow_img"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>',
								responsive: [{
									breakpoint: 768,
									settings: {
										slidesToShow: 1,
										dots: true,
									}
								}]
							});
							for (let i=0; i < $('.consumer-detail-slide01').length; i++) {
								let imgHeight = $('.consumer-detail-slide01-item img').eq(i).height() / 2;
								let arrowpos = imgHeight - ($('.consumer-detail-slide01').eq(i).find('.slick-arrow').height() / 2);
								$('.consumer-detail-slide01').eq(i).find('.slick-arrow').css('top',arrowpos);
							}
						}
						$('.js-consumerAccessories').removeClass('di_none');
					}
				});
			}
		}
	};
	const consumerSupportDownloadCatalog = () => {
		if($('.js-consumerSupportDownloadCatalog').length) {
			for(let i = 0 ; i < $('.js-consumerSupportDownloadCatalog').length; i++) {
				let id = $('.js-consumerSupportDownloadCatalog').eq(i).find('.cf_pc_code').text();
				let catalogUl = $('.js-consumerSupportDownloadCatalog').eq(i).find('.js-consumerSupportDownloadCatalog-list');
				let list = [];
				let HTML = '';
				const getJSONSupportDownloadCatalog1 = (_id) => {
					return $.getJSON(`/ajax/${lang}/consumer/support/download/catalog1/${_id}.json`);
				};
				const getJSONSupportDownloadCatalog2 = (_id) => {
					return $.getJSON(`/ajax/${lang}/consumer/support/download/catalog2/${_id}.json`);
				};
				const getJSONSupportDownloadCatalog3 = (_id) => {
					return $.getJSON(`/ajax/${lang}/consumer/support/download/catalog3/${_id}.json`);
				};
				const bytesToSize = (bytes) => {
					var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
					if(bytes === 0) {
							return'n/a';
					}
					var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
					if(i === 0) {
							return bytes + ' ' + sizes[i];
					}
					return(bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
				}
				getJSONSupportDownloadCatalog1(id).done((data1) => {
					// console.log(data1,'data1');
					if(data1.rt_bn_catalog_list.length) {
						data1.rt_bn_catalog_list.forEach((item, index) => {
							list.push(item.cf_p_catalog1);
						});
					}
					getJSONSupportDownloadCatalog2(id).done((data2) => {
						// console.log(data2,'data2');
						if(data2.rt_bn_catalog_list.length) {
							data2.rt_bn_catalog_list.forEach((item, index) => {
								list.push(item.cf_p_catalog2);
							});
						}
						getJSONSupportDownloadCatalog3(id).done((data3) => {
							// console.log(data3,'data3');
							if(data3.rt_bn_catalog_list.length) {
								data3.rt_bn_catalog_list.forEach((item, index) => {
									list.push(item.cf_p_catalog3);
								});
							}
							const result = list.filter((item, index, self) => {
								// _keyだけをリスト化する
								const keyList = self.map(item => item['_key']);
								// 重複を削除する
								if (keyList.indexOf(item._key) === index) {
								  return item;
								}
							});
							result.sort( function(a,b) {
								return Number(a.cf_pct_group_order) - Number(b.cf_pct_group_order);
							});
							// console.log(result,'result');
							result.forEach((item, index) => {
								// console.log(item,'item');
								let pageNum = '';
								if(item.cf_pct_page) {
									pageNum = ' / '+item.cf_pct_page+'p';
								}
								let date = new Date(item.cf_pct_release_date);
								let dataMM = Number(date.getMonth()) + 1;
								// console.log(item.cf_pct_release_date,'item.cf_pct_release_date');
								// console.log(date,'date');
								// console.log(dataMM,'dataMM');
								let downloadText,dateText,mmText;
								if(lang === 'jp') {
									downloadText = 'ダウンロード';
									dateText = '<p class="mod-spacer-16_8">'+date.getFullYear()+'年'+dataMM+'月発行<span>'+pageNum+'</span></p>';
								} else {
									downloadText = 'Download';
									if(dataMM == '1') {
										mmText = 'January'
									} else if(dataMM == '2') {
										mmText = 'February'
									} else if(dataMM == '3') {
										mmText = 'March'
									} else if(dataMM == '4') {
										mmText = 'April'
									} else if(dataMM == '5') {
										mmText = 'May'
									} else if(dataMM == '6') {
										mmText = 'June'
									} else if(dataMM == '7') {
										mmText = 'July'
									} else if(dataMM == '8') {
										mmText = 'August'
									} else if(dataMM == '9') {
										mmText = 'September'
									} else if(dataMM == '10') {
										mmText = 'October'
									} else if(dataMM == '11') {
										mmText = 'November'
									} else if(dataMM == '12') {
										mmText = 'December'
									}
									dateText = '<p class="mod-spacer-16_8">Published '+mmText+' '+date.getFullYear()+'<span>'+pageNum+'</span></p>';
								}
								HTML += '<li class="pure-u-1-2 pure-u-md-1-1 space-u-32-child space-md-48-child"><div class="consumer-catalogItem">'+
								'<figure class="consumer-catalogItem-figure"><img src="/jp/consumer/pc_file/file/'+item.cf_pct_thum_img+'" alt="'+item.cf_pct_name+'" class="height-auto width-u-100" loading="lazy" width="500" height="709"></figure>'+
								'<div class="consumer-catalogItem-lead">'+
								'<h4 class="mod-head04">'+
								'<span class="">'+item.cf_pct_name+'</span>'+
								'</h4>'+
								dateText+
								'<p class="mod-spacer-16_8">'+item.cf_pct_text+'</p>'+
								'<div class="mod-spacer-small">'+
								'<a href="'+item.cf_pct_attachment_file+'" target="_blank" class="mod-button _border _230 _md_215">'+
								'<span>'+downloadText+'(<span class="">'+bytesToSize(item.cf_pct_attachment_file_size)+'</span>)</span>'+
								'</a>'+
								'</div>'+
								'</div>'+
								'</div></li>';
							});
							catalogUl.append(HTML);
						});
					});
				});
			}
		}
	};
	const consumerA057Check = () => {
		if($('.js-a057_check').length) {
			const getJSONa057 = () => {
				return $.getJSON(`/jp/consumer/support/a057_check/a057_check.json`);
			};
			const listFilter = (_data) => {
				let chack = 'ng';
				if(!(isNaN($('.js-a057_check-input input').val()))) {
					if($('.js-a057_check-input input').val().length == '6') {
						chack = 'ng2';
					}
				}
				_data.forEach((elem) => {
					if($('.js-a057_check-input input').val() == elem.Id) {
						chack = 'ok';
					}
				});
				if(chack === 'ng') {
					$('.js-a057_check-input').addClass('di_none');
					$('.js-a057_check-result').addClass('di_none');
					$('.js-a057_check-error2').addClass('di_none');
					$('.js-a057_check-error').removeClass('di_none');
				} else if(chack === 'ng2') {
					$('.js-a057_check-input').addClass('di_none');
					$('.js-a057_check-result').addClass('di_none');
					$('.js-a057_check-error').addClass('di_none');
					$('.js-a057_check-error2').removeClass('di_none');
				} else if(chack === 'ok') {
					$('.js-a057_check-input').addClass('di_none');
					$('.js-a057_check-error').addClass('di_none');
					$('.js-a057_check-error2').addClass('di_none');
					$('.js-a057_check-result').removeClass('di_none');
				}
			};
			getJSONa057().done((data) => {
				$('.js-a057_check-input button').on('click', function () {
					listFilter(data);
				});
				if(!($(window).width() < 1025)) {
					$('.js-a057_check-input input').keypress(function(e){
						if(e.which === 13) {
							listFilter(data);
							return false;
						}
					});
				}
			});
		}
	};
	const consumerSupportDownloadFirmwareDetail = () => {
		if($('.js-consumer-support-download-firmware-detail-tableWrap').length) {
			if($('.js-consumer-support-download-firmware-detail-tableWrap table tbody tr').length) {
				for (let i=0; i < $('.js-consumer-support-download-firmware-detail-tableWrap table tbody tr').length; i++) {
					if(!($('.js-consumer-support-download-firmware-detail-tableWrap table tbody tr').eq(i).find('td:last-child').text().replace(/(^\s+)|(\s+$)/g, "").length)) {
						$('.js-consumer-support-download-firmware-detail-tableWrap table tbody tr').eq(i).addClass('is-hidden');
					}
				}
				if($('.js-consumer-support-download-firmware-detail-tableWrap table tbody tr.is-hidden').length == $('.js-consumer-support-download-firmware-detail-tableWrap table tbody tr').length) {
					$('.js-consumer-support-download-firmware-detail-tableWrap table tbody tr.is-hidden').find('td:last-child').addClass('di_none');
					$('.js-consumer-support-download-firmware-detail-tableWrap table thead tr').eq(0).find('th:last-child').addClass('di_none');
				}
			}
		}
	};
	const consumerLensesFilter67mm = () => {
		if($('.js-consumerLensesFilter67mm').length) {
			if($('.js-consumerLensesFilter67mm').length) {
				const getJSONmount = (_id) => {
					return $.getJSON(`/ajax/${lang}/consumer/${_id}/mount.json`);
				};
				for (let i=0; i < $('.js-consumerLensesFilter67mm').length; i++) {
					getJSONmount($('.js-consumerLensesFilter67mm').eq(i).find('.rt_cf_p_id').text()).done((data) => {
						if(!(data.rt_bn_mount_list.length)) {
							$('.js-consumerLensesFilter67mm').eq(i).addClass('di_none');
						}
					});
				}
			}
		}
	};
	const consumerSupportChecker = () => {
		if($('.js-consumer-support-checker').length) {
			// CSV取得
			const csvToArray = (strData) => {
				const strDelimiter = ',';
				const objPattern = new RegExp(
					(
						'(\\' + strDelimiter + '|\\r?\\n|\\r|^)' +
						'(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|' +
						'([^\"\\' + strDelimiter + '\\r\\n]*))'
					),
					'gi'
				);
				let arrData = [[]];
				let arrMatches = null;
				let strMatchedValue;
				while ((arrMatches = objPattern.exec(strData)) !== null) {
					let strMatchedDelimiter = arrMatches[1];
					if (strMatchedDelimiter.length && (strMatchedDelimiter !== strDelimiter)) {
						arrData.push([]);
					}
					if (arrMatches[2]) {
						strMatchedValue = arrMatches[2].replace(new RegExp('\"\"', 'g'), '\"');
					} else {
						strMatchedValue = arrMatches[3];
					}
					arrData[arrData.length - 1].push(strMatchedValue);
				}

				let items = arrData[0];
				let jsonArr = [];
				for (let i = 1; i < arrData.length - 1; i++) {
					if (arrData[i].length) {
						let a_line = {};
						let csvArrayD = arrData[i];
						for (let j = 0; j < items.length; j++) {
							a_line[items[j]] = csvArrayD[j];
						}
						jsonArr.push(a_line);
					}
				}
				return (jsonArr);
			};
			let csvData = new XMLHttpRequest();
			csvData.open('get', '/jp/consumer/support/checker/di.csv', true);
			csvData.send(null);
			csvData.onload = () => {
				let json = csvToArray(csvData.responseText);
				console.log(json,'json');
				Vue.createApp({
					data() {
						return {
							jsonData: json
						}
					},
					methods: {
						modalClick(items,other) {
							console.log(items,other);
							let HTML = '<div class="mod-modal-overlay">';
							HTML +=
								'<div class="mod-modal-closeArea"></div>' +
								'<div class="mod-modal-content">'+
								'<span class="mod-modal-closeBtn"><span></span></span>'+
								'<div class="mod-modal-content-in">' +
								'<p>ご使用いただけるカメラ</p>'+
								'<p class="mod-spacer-small">'+items+'</p>'+
								'<p class="mod-spacer-small">'+other+'</p>'+
								'</div></div></div>';
							$('body').append(HTML);
							const $overlay = $('.mod-modal-overlay');
							$overlay.addClass(a);
							setTimeout(() => {
								$overlay.addClass(v);
								$('.mod-modal-closeArea, .mod-modal-closeBtn').on('click', () => {
									$overlay.removeClass(v);
									setTimeout(() => {
										$overlay.removeClass(a);
										$overlay.remove();
									}, 400);
								});
							});
						},
					},
					computed: {
						tblItems() {
							let items = this.jsonData;
							let itemsTemp = [];
							for (let i = 0; i < items.length; i++) {
								items[i].items = items[i].items.replace(/\r\n|\r|\n/g, '<br>');
								itemsTemp.push(items[i]);
							}
							return (itemsTemp);
						}
					},
					mounted() {
					},
					updated() {
					}
				}).mount('#vue-app');
			};
		}
	};
	const consumerSpDuplicationProducts = () => {
		if(document.querySelectorAll('.js-consumer-DuplicationProductsHiddenWrap').length) {
			document.querySelectorAll('.js-consumer-DuplicationProductsHiddenWrap').forEach((_wrapItem,_wrapIndex) => {
				if(_wrapItem.querySelectorAll('.js-consumer-DuplicationProductsHidden').length) {
					let _array = [];
					_wrapItem.querySelectorAll('.js-consumer-DuplicationProductsHidden').forEach((item, index) => {
						_array.push({ id: item.querySelectorAll('.js-consumer-DuplicationProductsHidden-id')[0].textContent, idx: index });
					});
					// console.log(_array,'_array');
					// 重複削除
					const _array2 = _array.filter((item, index, self) => {
						// id だけをリスト化する
						const idList = self.map(item => item['id']);
						// 重複を削除する
						if (idList.indexOf(item.id) === index) {
						  return item;
						}
					});
					// console.log(_array2,'_array2');
					_wrapItem.querySelectorAll('.js-consumer-DuplicationProductsHidden').forEach((item, index) => {
						_array2.forEach((_array2Item) => {
							if(index == _array2Item.idx) {
								item.classList.remove('di_none');
							}
						});
					});
				} else {
					_wrapItem.classList.add('di_none');
				}
			});
		}
	};
	const consumerSoftLensutility = () => {
		if(document.querySelectorAll('.js-consumer-soft-lensutility-function-btn-mobile').length) {
			const urlParams = new URLSearchParams(window.location.search);
    		const mode = urlParams.get('mode');
			if (mode === 'sp') {
				// mode=spの場合の初期設定
				$('.js-consumer-soft-lensutility-function-btn-pc').removeClass(a);
				$('.js-consumer-soft-lensutility-function-btn-mobile').addClass(a);
				$('.js-consumer-soft-lensutility-function-item').removeClass(a);
			} else if (mode === 'pc') {
				// mode=pcの場合の初期設定
				$('.js-consumer-soft-lensutility-function-btn-mobile').removeClass(a);
				$('.js-consumer-soft-lensutility-function-btn-pc').addClass(a);
				$('.js-consumer-soft-lensutility-function-item').addClass(a);
			}
			$('.js-consumer-soft-lensutility-function-btn-mobile').on('click', () => {
				$('.js-consumer-soft-lensutility-function-btn-pc').removeClass(a);
				$('.js-consumer-soft-lensutility-function-btn-mobile').addClass(a);
				for (let i=0; i < $('.js-consumer-soft-lensutility-function-item').length; i++) {
					$('.js-consumer-soft-lensutility-function-item').eq(i).removeClass(a);
				}
				// URL パラメータを追加または更新
				const url = new URL(window.location.href);
				url.searchParams.set('mode', 'sp');
				window.history.replaceState(null, '', url); // URLを更新（ページ遷移しない）
			});
			$('.js-consumer-soft-lensutility-function-btn-pc').on('click', () => {
				$('.js-consumer-soft-lensutility-function-btn-mobile').removeClass(a);
				$('.js-consumer-soft-lensutility-function-btn-pc').addClass(a);
				for (let i=0; i < $('.js-consumer-soft-lensutility-function-item').length; i++) {
					$('.js-consumer-soft-lensutility-function-item').eq(i).addClass(a);
				}
				// URL パラメータを追加または更新
				const url = new URL(window.location.href);
				url.searchParams.set('mode', 'pc');
				window.history.replaceState(null, '', url); // URLを更新（ページ遷移しない）
			});
		}
		if(document.querySelectorAll('.js-consumer-soft-lensutilityimgset').length) {
			const getImg = (_src) => {
				return new Promise((resolve, reject) => {
					const image = new Image();
					image.src = _src;
					image.onload = () => { resolve(image); }
					image.onerror = (error) => { reject(error); }
				});
			};
			const imgs = document.getElementsByTagName('img');
			for (const img of imgs) {
				const src = img.getAttribute('src');
				getImg(src).then((res) => {
					if (!img.hasAttribute('width')) {
						img.setAttribute('width', res.width);
					}
					if (!img.hasAttribute('height')) {
						img.setAttribute('height', res.height);
					}
				})
					.catch((error) => { console.log(error); });
			}
		}
	};
	slider();
	consumerFilter();
	consumerDetailNav();
	modal();
	moreItem();
	consumerLensesTop();
	consumerSearch();
	consumerTop();
	consumerLensesDiscontinued();
	consumerSpImpressionDetail();
	consumerAccessories();
	consumerSupportDownloadCatalog();
	consumerA057Check();
	consumerSupportDownloadFirmwareDetail();
	consumerLensesFilter67mm();
	consumerSpDuplicationProducts();
	consumerSupportChecker();
	consumerSoftLensutility();

})(window.jQuery, window.FUNCTIONS);
$(window).on('load', function () {
	if($('.consumer-slide02').length) {
		$('.consumer-slide02').slick({
			autoplay: false,
			slidesToShow: 4,
			slidesToScroll: 1,
			dots: false,
			arrows: false,
			infinite: true,
			draggable: false,
			responsive: [{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
					draggable: true,
					arrows: true,
					prevArrow: '<a class="slick-prev" href="#"><svg class="slick-arrow_img"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></a>',
					nextArrow: '<a class="slick-next" href="#"><svg class="slick-arrow_img"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></a>',
					
				}
			}]
		});
		for (let i=0; i < $('.consumer-slide02').length; i++) {
			let imgHeight = $('.consumer-slide02-item img').eq(i).height() / 2;
			let arrowpos = imgHeight - ($('.consumer-slide02').eq(i).find('.slick-arrow').height() / 2);
			$('.consumer-slide02').eq(i).find('.slick-arrow').css('top',arrowpos);
		}
		$('.consumer-slide02 .consumer-slide02-item').matchHeight();
		$('.consumer-slide02 .consumer-slide02-item figure').matchHeight();
	}
});
